const TONES = {
  white: "bg-white border-brand-200 hover:border-brand-500",
  brandTint: "bg-brand-50 border-brand-100 hover:border-brand-500",
  sunTint: "bg-brand-50 border-brand-200 hover:border-brand-500",
  brand: "bg-brand-500 border-brand-500 text-white",
  sun: "bg-brand-50 border-brand-200 text-ink",
};

/**
 * Rounded card. Renders an <article> by default (project rule for cards).
 * `wiggle` is kept for compatibility and does nothing; `shadow` adds a soft shadow.
 */
export function StickerCard({
  as: Tag = "article",
  tone = "white",
  wiggle = true,
  shadow = false,
  className = "",
  children,
  ...rest
}) {
  return (
    <Tag
      className={`rounded-3xl border p-5 transition-all duration-200 sm:p-6 ${TONES[tone] ?? TONES.white} ${
        wiggle ? "" : ""
      } ${shadow ? "shadow-sticker" : ""} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}
